export default "__VITE_ASSET__DQ4XzsO6__"